import { getGscRedirectStaticUri, GSC_OAUTH_STORAGE_KEY, GSC_SERVICE_NAME } from '#shared/lib/const';
import { getGscOauthUrl } from '#shared/lib/url';
import { connectIntegrationGoogleSearchConsole, integrationGscCredentialsGet } from '../api/googleSearchConsoleApi';
import { useOauthPopupConnect } from './useOauthPopupConnect';

type UseGoogleSearchConsoleConnectIntegrationParams = {
    onSuccess: () => Promise<unknown>;
};

export function useGSCConnectIntegration({ onSuccess }: UseGoogleSearchConsoleConnectIntegrationParams) {
    const { isConnecting, handleConnect } = useOauthPopupConnect({
        cookieKey: GSC_OAUTH_STORAGE_KEY,
        serviceName: GSC_SERVICE_NAME,
        getCredentials: integrationGscCredentialsGet,
        buildUrl: getGscOauthUrl,
        onCookieSuccess: async ({ code, state }) => {
            await connectIntegrationGoogleSearchConsole({
                code,
                redirect_uri: getGscRedirectStaticUri(),
                state_token: state,
            });

            await onSuccess();
        },
    });

    return { isConnecting, handleConnect };
}
